'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import Helmet from 'react-helmet'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _About = require('./About.css');

var _About2 = _interopRequireDefault(_About);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var About = (_dec = (0, _reactCssModules2.default)(_About2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(About, _Component);

  function About(props) {
    (0, _classCallCheck3.default)(this, About);

    var _this = (0, _possibleConstructorReturn3.default)(this, (About.__proto__ || (0, _getPrototypeOf2.default)(About)).call(this, props));

    _this.renderTop = function () {
      return _react2.default.createElement(
        _components.Link,
        { strong: true, title: 'Back to top', to: '#top' },
        'Back to Top'
      );
    };

    _this.renderAboutContent = function (aboutTitle) {
      var toIcon = require('../../../static/images/icon-cigarette.svg');
      var tmIcon = require('../../../static/images/icon-cinema.svg');
      return _react2.default.createElement(
        'div',
        { styleName: 'about' },
        _react2.default.createElement(
          'div',
          { styleName: 'about-inner' },
          _react2.default.createElement(
            'h1',
            { styleName: 'title' },
            aboutTitle
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Tobacco Free Funds'
              ),
              ' empowers investors to search their mutual funds for tobacco companies and the entertainment companies that promote tobacco to young people. We help you identify investment options that align with your values and build a healthier future.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We screen funds for two types of companies:'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'bullets' },
              _react2.default.createElement('img', { src: toIcon, styleName: 'bullet-icn', alt: 'Tobacco manufacturers' }),
              _react2.default.createElement(
                'div',
                { styleName: 'bullet-copy' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Tobacco manufacturers.'
                ),
                ' These companies\u2019 largest source of revenue and income is the production, sale and/or marketing of cigarettes, cigars, and other tobacco products. Five tobacco firms dominate international markets: Phillip Morris International, Altria, British American Tobacco (which owns Reynolds American), Imperial Tobacco, and Japan Tobacco. Tobacco manufacturers are identified using Morningstar\'s industry classifications.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'bullets' },
              _react2.default.createElement('img', { src: tmIcon, styleName: 'bullet-icn', alt: 'Entertainment companies' }),
              _react2.default.createElement(
                'div',
                { styleName: 'bullet-copy' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Entertainment companies that promote tobacco in kid-rated movies.'
                ),
                ' \u201CR\u201D-rating future movies with smoking will prevent one million tobacco deaths in this generation of U.S. kids. Hollywood studios and their parent companies, the nation\u2019s best-known entertainment companies, are well aware of the public health risk, but continue to intentionally expose millions of kids. To learn more about which entertainment companies we flag as tobacco-promoting, ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.faq, xstrong: true, title: 'FAQ' },
                  'see the FAQ.'
                )
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Tobacco Free Funds'
              ),
              ' is funded in part by a grant from Truth Initiative.'
            )
          ),
          _react2.default.createElement(
            _components.Link,
            {
              to: _config2.default.routes.clean,
              title: 'Get started with Tobacco Free Funds' },
            _react2.default.createElement(
              'div',
              { styleName: 'link-style' },
              'Get started',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        )
      );
    };

    _this.renderXPanels = function () {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'x-401k-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-401k-container-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-401k-info-photo' },
              _react2.default.createElement('div', { styleName: 'x-401k-photo', title: 'Retirement plans image' }),
              _react2.default.createElement(
                'div',
                { styleName: 'x-401k-info' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-401k-info-title' },
                  'Retirement plans'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Retirement plans invest mostly in mutual funds, which are themselves invested in a wide array of company stocks and other securities. It\u2019s not always easy for investors to investigate what\u2019s inside the funds they own. Your retirement money may be invested in tobacco companies and entertainment companies that promote tobacco to kids. If you want tobacco-free options in your retirement account, ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.routes.toolkit, xstrong: true, title: '401k toolkit' },
                    'talk to your plan administrator.'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'x-ays-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-ays-container-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-ays-info-photo' },
              _react2.default.createElement('div', { styleName: 'x-ays-photo', title: 'As You Sow image' }),
              _react2.default.createElement(
                'div',
                { styleName: 'x-ays-info' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-ays-info-title' },
                  'As You Sow'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'At ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.ays, xstrong: true, title: 'As You Sow' },
                    'As You Sow,'
                  ),
                  ' we\u2019ve been engaging major corporations on social and environmental responsibility since 1992. In 2015, we launched ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.fff, xstrong: true, title: 'Fossil Free Funds' },
                    'Fossil Free Funds'
                  ),
                  ' so that people could see if their retirement was funding climate change. Since then our Invest Your Values program has released free sustainable investing tools on environmental and social issues like gender equality, deforestation, and more. We are committed to transparency, corporate accountability, and empowering individuals to take control of their investments.'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'x-desktop-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-desktop-container-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-desktop-info-photo' },
              _react2.default.createElement('div', { styleName: 'x-desktop-photo', title: 'Computer with Tobacco Free Funds image' }),
              _react2.default.createElement(
                'div',
                { styleName: 'x-desktop-info' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-desktop-info-title' },
                  'How Tobacco Free Funds Works'
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    'Look up mutual funds using up-to-date Morningstar data'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'We analyze your investments for tobacco stocks'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'See how much exposure they have to tobacco and tobacco-promoting entertainment companies'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-desktop-link' },
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.works,
                      title: 'How it works | Tobacco Free Funds'
                    },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'press-link' },
                      'See how it works',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-desktop-info-title' },
                  'Use our action toolkit'
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    'Learn how to make a change and invest tobacco free'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'Ask your financial advisor about socially responsible investments'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'Push your employer to provide tobacco free 401(k) options'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-desktop-link' },
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.toolkit,
                      title: 'Action toolkit | Tobacco Free Funds'
                    },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'press-link' },
                      'View the action toolkit',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'img-attrib-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'img-attrib-container-inner' },
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.media,
                alt: 'Media | Tobacco Free Funds'
              },
              _react2.default.createElement(
                'div',
                { styleName: 'press-link' },
                'Visit our media page',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          )
        )
      );
    };

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(About, [{
    key: 'render',
    value: function render() {
      var title = 'About';
      var link = _config2.default.domain + _config2.default.routes.about;
      var message = _config2.default.shareMessage;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _container2.default.helmet(title),
          this.renderAboutContent(title),
          this.renderXPanels()
        ),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(_components.DonateBanner, null)
      );
    }
  }]);
  return About;
}(_react.Component)) || _class);
exports.default = About;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/About/About.js
// module id = 1285
// module chunks = 0